import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};
const DateTime = (_param)=>{
    var { dateTime  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "dateTime"
    ]);
    const date = dateTime instanceof Date ? dateTime : new Date(dateTime);
    let { locale  } = rest;
    if (locale) {
        // Browsers require BCP 47 language tag format (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument)
        locale = locale.replace('_', '-');
    }
    return /*#__PURE__*/ React.createElement("time", {
        dateTime: date.toISOString()
    }, date.toLocaleDateString(locale, options));
};

export { DateTime as default, options };
//# sourceMappingURL=DateTime.js.map
